import openWindow from './openWindow';
import parseIterator from '../stdlib/parseIterator';
import { URL_REL_WKSPC } from '../config/url-consts';
const setQueryString = (params, authorizeUser) => {
  const keys = ['acctId', 'conId', 'rlshpId', 'vndrAcctId'];
  const active = keys.filter(key => params[key]);
  const authVal = authorizeUser === false ? 'F' : 'T';
  let query = active.map(key => `${key}=${params[key]}`).join('&');
  query += `&authorizeUser=${authVal}`;
  return query.replace('vndrAcctId', 'vndrAcctNo');
};
const parseParams = parmSet => {
  const params = parseIterator(new URLSearchParams(parmSet));
  switch (true) {
    case params.type === 'P':
      params.conId = params.number;
      return params;
    case !params.ctryCd:
      if (params.acctId) return params;
      if (params.vndrAcctId) return params;
      params.vndrAcctId = params.number;
      return params;
    case params.ctryCd === 'US' && !params.vndrAcctId:
      params.vndrAcctId = params.number;
      return params;
    case !params.acctId:
      params.acctId = params.number;
      return params;
    default:
      return params;
  }
};
const setWorkspaceUrl = (appId, params, authorizeUser, parmSet) => {
  const baseUrl = URL_REL_WKSPC(window.location.href);
  const queryString = setQueryString(params, authorizeUser);
  const encodedParms = encodeURIComponent(parmSet);
  return `${baseUrl}?appId=${appId}&${queryString}&parmSet=${encodedParms}`;
};
const hasRequired = params => {
  if (params.acctId) return true;
  if (params.conId) return true;
  if (params.rlshpId) return true;
  if (params.vndrAcctId) return true;

  // eslint-disable-next-line no-console
  console.error('ERROR : UXD-COMMON-UTILS : displayRelWkspc()', '\n', 'One of the following values must be set in the second argument passed to displayRelWkspc:', '\n', '  - acctId', '\n', '  - conId', '\n', '  - rlshpId', '\n', '  - vndrAcctId');
  return false;
};
const setWindowConfig = winURL => {
  const {
    floor,
    random
  } = Math;
  const {
    availWidth,
    availHeight
  } = window.screen;
  return {
    winURL,
    winName: '_blank',
    winParams: 'resizable=1,status=1,scrollbars=0',
    winWidth: Math.min(Math.floor(availWidth * 0.87), Math.floor(1320 * 0.75) // $breakpoint_big_desktop: 1320
    ),

    winHeight: floor(availHeight * 0.85),
    winLeft: floor(availHeight * ((random() + 1) / 45)),
    winTop: floor(availWidth * ((random() + 1) / 45))
  };
};
const displayRelWkspc = (appId, parmSet, authorizeUser) => {
  const params = parseParams(parmSet);
  if (!hasRequired(params)) return;
  const url = setWorkspaceUrl(appId, params, authorizeUser, parmSet);
  openWindow(setWindowConfig(url));
};
export default displayRelWkspc;
//# sourceMappingURL=displayRelWkspc.js.map